import pathToRegexp             from 'path-to-regexp';
import PropTypes                from 'prop-types';
import React, { Component }     from 'react';
import { Route as RouterRoute } from 'react-router-dom';
import setDisplayName           from 'recompose/setDisplayName';
import withProps                from 'recompose/withProps';
import wrapDisplayName          from 'recompose/wrapDisplayName';


/**
 * @property {string}          relativePath
 * @property {string}          fullPath
 * @property {?Route}          parent
 * @property {Route[]}         routes
 * @property {function(Route)} addRoute
 * @property {*}               routeComponent
 * @property {*[]}             subRouteComponent
 * @property {object}          props
 *
 */
class Route {

  static argTypes = {
    name:         PropTypes.string.isRequired,
    relativePath: PropTypes.string,
    parent:       PropTypes.instanceOf(Route),
    exact:        PropTypes.bool,
    strict:       PropTypes.bool,
    component:    PropTypes.oneOfType([PropTypes.instanceOf(Component), PropTypes.instanceOf(Function)]).isRequired,
    props:        PropTypes.object,
  };


  /**
   * @param {string}   name
   * @param {string}   relativePath
   * @param {Route}    parent
   * @param {boolean}  exact
   * @param {boolean}  strict
   * @param {function} component
   * @param {object}   props
   */
  constructor(
    {
      name,
      relativePath,
      component,
      parent = null,
      exact = false,
      strict = false,
      props = {},
    },
  ) {

    PropTypes.checkPropTypes(
      Route.argTypes,
      {name, relativePath, parent, exact, strict, component, props},
      'arg',
      this.__proto__.constructor.name,
    );

    // Store properties

    const fullPath = `${parent ? parent.fullPath : ''}${relativePath || ''}`;

    let routes = [];

    if (parent) {

      parent.addRoute(this);

    }

    let routerComponent;

    function updateRouteComponent() {

      const routeProps = {
        path:      fullPath,
        exact,
        strict,
        component: setDisplayName(wrapDisplayName(component, 'WithRouteConfigProps'))(
          withProps({...props, route: this, routes})(component),
        ),
      };

      routerComponent = <RouterRoute {...routeProps} key={fullPath || '__root__'}/>;

    }

    updateRouteComponent();

    Object.defineProperties(this, {

      relativePath: {
        configurable: false,
        enumerable:   true,
        get:          () => relativePath || '',
      },

      fullPath: {
        configurable: false,
        enumerable:   true,
        get:          () => fullPath,
      },

      parent: {
        configurable: false,
        enumerable:   true,
        get:          () => parent,
      },

      routes: {
        configurable: false,
        enumerable:   true,
        get:          () => routes,
      },

      addRoute: {
        configurable: false,
        enumerable:   false,
        value:        ((subRoute) => {

          PropTypes.checkPropTypes({subRoute: PropTypes.instanceOf(Route).isRequired}, {subRoute});

          routes = routes.concat(subRoute);

          updateRouteComponent();

        }),
      },

      routeComponent: {
        configurable: true,
        enumerable:   true,
        get:          () => {
          return routerComponent;
        },
      },

      component: {
        configurable: false,
        enumerable:   true,
        get:          () => component,
      },

    });

  }


  /**
   * Compiles the route with the given params
   *
   * @param {object} params
   *
   * @return {string}
   */
  compile(params = {}) {

    return pathToRegexp.compile(this.fullPath)(params);

  }

}


Route.ComponentPropTypes = {

  // The Route object for the route.
  route: PropTypes.instanceOf(Route).isRequired,

  // The sub-routes for the route.
  routes: PropTypes.arrayOf(PropTypes.instanceOf(Route)).isRequired,

  // Router match.
  match: PropTypes.object.isRequired,

};


export default Route;



// WEBPACK FOOTER //
// ./src/config/Route.js